import "../css/PopUpCTA.css"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons'

export default function PopUp() {
    return (
        <section className="pop-up">
            <div className="container--popup">
                <a href="https://wa.me/390575381414" target="_blank" rel="noopener noreferrer">
                    <button className="button--popup">
                        <FontAwesomeIcon icon={faWhatsapp} className="fa-whatsapp" />
                        Contattaci
                    </button>
                </a>
            </div>
        </section>
    )
}